// Vendor imports
const { connect } = require('react-redux')
const { defaultMemoize } = require('reselect')
// Entry imports
const tooltipActions = require('./actions')
const WithTooltip = require('./component-dumb')

function mapStateToProps() {
  const memoizedRender = defaultMemoize(tooltipItem => {
    return tooltipItem.render.bind(tooltipItem)
  })
  return function (state, props) {
    const { tooltips } = state
    const tooltipItem = tooltips && tooltips.getItem(props.tooltipKey)
    if (!tooltipItem) {
      // Pass-through if tooltip is not available
      return {}
    }
    if (tooltipItem.uniqueId != null) {
      if (tooltipItem.uniqueId !== props.uniqueId) {
        // Pass-through if tooltip unique ID does not match
        return {}
      }
    }
    return {
      isDismissed: tooltipItem.isDismissed,
      renderBubbleChildren: memoizedRender(tooltipItem)
    }
  }
}

const mapDispatchToProps = {
  onDismiss: tooltipActions.dismissTooltip
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  WithTooltip
)
